import React, { useState } from 'react'
import {
  useLocation,
  NavLink,
} from "react-router-dom"
import { find, map } from 'lodash'

import Eyebrow from './components/Eyebrow'
import Footer from './components/Footer'
import './assets/css/main.scss'
import EcsLogoSvg from './assets/images/ecs_logo.svg'
import CloseSvg from './assets/images/close.svg'
import { generateUrl } from './helpers/clinic'

export default ({data, children}) => {
  const [mobileNavVisible, setMobileNavVisible] = useState(false)
  const path = window.location.pathname.split('/')[1] // purge leading slash
  const location = useLocation()

  React.useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  const clinic = find(data.clinics, (c) => {
    return c.url === path
  })

  const toggleMobileNav = () => {
    if (mobileNavVisible) {
      resetMobileNav()
    } else {
      showMobileNav()
    }
  }

  const resetMobileNav = () => {
    setMobileNavVisible(false)
    window.removeEventListener('resize', resetMobileNav, true)
  }

  const showMobileNav = () => {
    setMobileNavVisible(true)
    window.addEventListener('resize', resetMobileNav, true)
  }

  const clickLink = (e) => {
    resetMobileNav()
  }

  const homeLink = '/' //generateUrl(clinic, '')
  const aboutLink = generateUrl(clinic, 'about')
  const servicesLink = generateUrl(clinic, 'services')
  const contactLink = generateUrl(clinic, 'contact')

  const patientsLink = generateUrl(clinic, 'patients')

  const mobileStyle = "py-2 px-4 border-b border-slate-300"

  return (
    <div className="bg-[#fafafa]">
      <div className={`z-50 fixed text-lg min-h-screen top-0 bg-white overflow-hidden mobile-menu transition-width duration-500 ease-in-out w-[0%] ${mobileNavVisible ? 'w-[100%] block' : ''} `}>
        <div className="max-w-6xl mx-auto">

          <ul className="mobile-nav">
            <li className="px-4 py-4 border-b border-slate-300 relative">
              <a href="/" className="inline-block"><img src={EcsLogoSvg} className="ecs-logo-single-line-header w-64 min-w-64 max-w-4/5 " alt="Eye Clinics of Seattle" /></a>
              <img src={CloseSvg} className="absolute right-8 top-[16px] w-6 h-6 cursor-pointer select-none" alt="close mobile menu" onClick={clickLink}/>
            </li>
            <NavLink to={homeLink} onClick={clickLink}><li className={mobileStyle}>Home</li></NavLink>
            <NavLink to={aboutLink} onClick={clickLink}><li className={mobileStyle}>About</li></NavLink>
            <NavLink to={servicesLink} onClick={clickLink}><li className={mobileStyle}>Services</li></NavLink>
            <NavLink to={patientsLink} onClick={clickLink}><li className={mobileStyle}>Patients</li></NavLink>
            {
              clinic && clinic.payUrl && 
              <a href={clinic.payUrl} target="_blank" rel="noreferrer">
                <li className={mobileStyle}>Pay Bill</li>
              </a>
            }

            {
              !clinic &&
              <React.Fragment>
                <NavLink to={'/pay-bill'} onClick={clickLink}>
                  <li className={mobileStyle}>Pay Bill</li>
                </NavLink>
                <NavLink to={'/appointments'} onClick={clickLink}>
                  <li className={mobileStyle}>Make an Appointment</li>
                </NavLink>
              </React.Fragment>
            }
            {
              clinic && clinic.appointmentUrl && 
              <a href={clinic.appointmentUrl} target="_blank" rel="noreferrer">
                <li className={mobileStyle}>Schedule Appointment</li>
              </a>
            }
            {
              clinic && clinic.buyContactsUrl && 
              <a href={clinic.buyContactsUrl} target="_blank" rel="noreferrer">
                <li className={mobileStyle}>Order Contacts</li>
              </a>
            }
            <NavLink to={contactLink} onClick={clickLink}><li className={mobileStyle}>Contact Us</li></NavLink>

            <br/>
            <div className="ml-4 mb-2 font-semibold">Our Clinics</div>
            {
              map(data.clinics, (c, ndx) => {
                return (
                  <a href={`/${c.url}`} key={`frame-clinic-${ndx}`}>
                    <li className={`${mobileStyle} ${ ndx === 0 ? 'border-t' : ''} ${ clinic === c ? 'font-semibold' : ''} pl-6 text-sm`} >{c.name}</li>
                  </a>
                )
              })
            }
          </ul>
        </div>
      </div>
      <Eyebrow data={data} />
      <nav className="bg-white ecs-navbar sticky z-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-between h-12 md:h-20">
            <div className="flex items-center space-x-7">
              <div className="md:flex md:flex-1 items-center logo">
                <NavLink to={homeLink}>
                  <img src={EcsLogoSvg} className="ecs-logo-single-line-header w-[230px] md:w-[270px] cursor-pointer" alt="Eye Clinics of Seattle" />
                </NavLink>
              </div>
            </div>
            {/* <div className="hidden md:flex items-center space-x-8 desktop-nav"> */}
            <div className="hidden items-center space-x-8 desktop-nav">
              <NavLink to={homeLink}>Home</NavLink>
              <NavLink to={aboutLink}>About</NavLink>
              <NavLink to={servicesLink}>Services</NavLink>
              <NavLink to={contactLink}>Contact</NavLink>
            </div>
            <div className="flex items-center">
              <button className="outline-none mobile-menu-button" onClick={toggleMobileNav}>
    						<svg className=" w-6 h-6 text-gray-500 hover:text-cyan-500 "
    							x-show="!showMenu"
    							fill="none"
    							strokeLinecap="round"
    							strokeLinejoin="round"
    							strokeWidth="2"
    							viewBox="0 0 24 24"
    							stroke="currentColor"
    						>
    							<path d="M4 6h16M4 12h16M4 18h16"></path>
    						</svg>
					    </button>
            </div>
          </div>
        </div>
      </nav>
      <main>
        {children}
      </main>
      <Footer data={data} clinic={clinic} />
    </div>
  )
}